import { EOperationTypes } from '../enums/EOperationTypes';
import { ETolgeeDefault } from '../enums/ETolgeeDefault';

export const OPERATION_TYPES = [
  {
    value: EOperationTypes.ADHESION,
    label: ETolgeeDefault.ENUM_OPERATION_TYPES_ADHESION
  },
  {
    value: EOperationTypes.COMPLETE_CHANGE,
    label: ETolgeeDefault.ENUM_OPERATION_TYPES_COMPLETE_CHANGE
  },
  {
    value: EOperationTypes.SIMPLE_CHANGE,
    label: ETolgeeDefault.ENUM_OPERATION_TYPES_SIMPLE_CHANGE
  },
  {
    value: EOperationTypes.REACTIVATION,
    label: ETolgeeDefault.ENUM_OPERATION_TYPES_REACTIVATION
  },
  {
    value: EOperationTypes.SUSPENSION,
    label: ETolgeeDefault.ENUM_OPERATION_TYPES_SUSPENSION
  }
];
